import { renderIcon } from '../../SvgIcon.esm.js';

/******************************************************
 * This file was created by scripts/generate.js as part
 * of the build process. Do not edit this file directly.
 ******************************************************/
var iconType = {
  viewBox: "0 0 24 24",
  paths: [{
    d: "M12 3c4.74 0 9 3.73 9 9.22.59.31 1 .92 1 1.62v2.3c0 .72-.41 1.33-1 1.64V19c0 1.1-.9 2-2 2h-7c-.55 0-1-.45-1-1l.0068-.1162C11.0648 19.388 11.4893 19 12 19h7v-7.1c0-3.94-3.26-7.12-7.22-7C7.95 5.01 5 8.36 5 12.19V17c0 .55-.45 1-1 1l-.1487-.0055C2.82 17.9178 2 17.05 2 16v-2c0-.74.4-1.38 1-1.72C3 6.65 7.31 3 12 3zm-3 9c.5523 0 1 .4477 1 1s-.4477 1-1 1-1-.4477-1-1 .4477-1 1-1zm6 0c.5523 0 1 .4477 1 1s-.4477 1-1 1-1-.4477-1-1 .4477-1 1-1zm-2.95-6c2.99 0 5.47 2.18 5.95 5.03-3.12-.03-5.81-1.84-7.12-4.47-.53 2.68-2.39 4.88-4.86 5.89C5.76 8.51 9.02 6 12.05 6z",
    fillRule: "evenodd"
  }],
  circles: []
};
var SupportAgentIcon = function SupportAgentIcon(props) {
  return renderIcon(props, iconType);
};
export { SupportAgentIcon };